import React, { useLayoutEffect, useRef, useState } from 'react';
import CustomCard from '../../../../../components/CustomCard';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {  IconFingerprint, TrashOutlineIcon } from '../../../../../components/buttons/IconButtons';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import DeleteModal from '../../../../Modals/DeleteModal';
import TableFunction from '../../../../../components/table/TableFunction';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import NotInformation from '../../../../../components/NotInformation';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { TABLES } from '../../../../../Apis/Tables';
import { FINGERPRINT_SOURCE_MODEL } from '../Model/Models';
import { errorMsg } from '../../../../../Apis/functions';
/**
 *
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */
const FingerprintsTable = ({
    fingerprintsList,
    setFingerprintsTemp,
    userData,
    mergedFingerprints,
    setUpdated
}) => {
    /**
     * Stores the ids of selected fingerprints
     * used for bulk actions.
     */
    const [selectedList, setSelectedList] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [deleteFingerprintShow, setDeleteFingerprintShow] = useState(false);
    const [idsToDelete, setIdsToDelete] = useState([]);

    const dispatch = useDispatch();

    /**
     * Reference used to calculate dynamic
     * sticky position values.
     */
    const elementRef = useRef(null);

    const { t, handleDeleteAll } = TableFunction({
        selectedList,
        setSelectedList,
        data: { content: mergedFingerprints },
        setIsAllChecked,
    });

    /**
     * Synchronizes the "select all" checkbox state
     * with the currently selected fingerprints.
     */
    useEffect(() => {
        if (selectedList.length === mergedFingerprints.length && mergedFingerprints.length > 0) {
            setIsAllChecked(true);
        } else {
            setIsAllChecked(false);
        }
    }, [selectedList, fingerprintsList]);

    /**
     * Deletes fingerprints from temporary state
     * and/or backend depending on their source.
     */
    const handleConfirmDelete = async () => {
        const tableName = TABLES.USER_IMAGE;

        try {
            const ids = idsToDelete;

            const serverIdsToDelete = [];
            const tempIdsToDelete = [];

            ids.forEach((id) => {
                const item = mergedFingerprints.find((f) => f.id === id);
                if (!item) return;

                if (item.source === FINGERPRINT_SOURCE_MODEL.TEMP) {
                    tempIdsToDelete.push(id);
                } else {
                    serverIdsToDelete.push(id);
                }
            });

            if (tempIdsToDelete.length > 0) {
                setFingerprintsTemp((prev) => prev.filter((f) => !tempIdsToDelete.includes(f.id)));
            }

            if (serverIdsToDelete.length > 0 && userData?.id) {
                await dispatch(
                    DeleteItemsApi({
                        tableName,
                        body: serverIdsToDelete,
                    }).then(
                                ({
                                    payload: {
                                        data: { code },
                                    },
                                }) => {
                                   {
                                        errorMsg(code);
                                    }
                                },
                            )
                );

                setUpdated(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIdsToDelete([]);
            setDeleteFingerprintShow(false);
            setSelectedList([]);
            setIsAllChecked(false);
        }
    };

     /**
     * Calculates dynamic top offset used by
     * sticky/floating table elements.
     */
    useLayoutEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 90;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    return (
        <>
            <div className={"border-full-shades-300 border-radius-8px h-100 d-flex flex-column"}>
                <div>
                    <div className='d-flex align-items-center justify-content-between p-2'>
                        <div className='d-flex align-items-center'>
                            <div className='mr-2'>
                                <CustomTooltip
                                    text={t('fingerprints')}
                                    classes='font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row'
                                    showIfTruncated
                                />
                            </div>

                            <div className='d-flex justify-content-center align-items-center border-radius-8px w-20px background-shades-200 border-full-shades-150'>
                                <p className='fs-14px ibl-font-w-500 font-color-shades-500 px-1'>
                                    {mergedFingerprints.length}
                                </p>
                            </div>
                        </div>

                        <ButtonAction
                            id='btn_fpt_delete'
                            name='delete'
                            className='btn-icon-delete'
                            disabled={selectedList.length === 0}
                            Icon={TrashOutlineIcon}
                            onClick={() => {
                                setIdsToDelete(selectedList);
                                setDeleteFingerprintShow(true);
                            }}
                        />
                    </div>

                    <div className='col-12 border-bottom-shades-300' />
                </div>

                { fingerprintsList.length > 0 &&
                    <div className='row py-2'>
                        <CustomCheckbox
                            id='select_all'
                            name='selectAll'
                            trans={t('de_/_select_all').toUpperCase()}
                            tooltip={t('deSelectAll')}
                            checked={isAllChecked}
                            indeterminate={selectedList.length > 0 && selectedList.length < fingerprintsList.length}
                            onChange={handleDeleteAll}
                            marginbutton={true}
                        />
                    </div>
                }

                <div className='row flex-grow-1'>
                    {mergedFingerprints.length > 0 ? (
                        mergedFingerprints.map((item) => (
                            <div key={item.id} className='col-sm-6 col-md-6 col-lg-4 mb-2'>
                                <CustomCard
                                    classes='w-100 background-shades-50 border-radius-8px p-0'
                                    classCard='border-radius-8px'
                                >
                                    <div className='row align-items-center'>
                                        <div className='col-2 d-flex justify-content-center align-self-start'>
                                            <CustomCheckbox
                                                className='p-0 m-0'
                                                id={item.id}
                                                checked={selectedList.includes(item.id)}
                                                onChange={() => {
                                                    setSelectedList((prev) => {
                                                        if (prev.includes(item.id)) {
                                                            return prev.filter((id) => id !== item.id);
                                                        } else {
                                                            return [...prev, item.id];
                                                        }
                                                    });
                                                }}
                                            />
                                        </div>

                                        <div className='col-8 m-0 p-0'>
                                            <div className='row m-0 p-0'>
                                                <div className='col-12 p-0 m-0 d-flex align-items-center'>
                                                    <div className='mr-2'>
                                                        <IconFingerprint />
                                                    </div>

                                                    <div className='flex-grow-1 minw-0'>
                                                        <CustomTooltip
                                                            text={item.description || item.name}
                                                            classes='fs-12px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row'
                                                            showIfTruncated
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-12 border-bottom-shades-300 my-2' />

                                                <div className='col-12 p-0 m-0'>
                                                    <span className='font-color-shades-800 fs-14px ibl-font-w-400'>
                                                        {t('fingerprint')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-2 d-flex justify-content-center p-0 m-0'>
                                            <TrashOutlineIcon
                                                className='icon-color-shades-400 cursor-pointer'
                                                onClick={() => {
                                                    setIdsToDelete([item.id]);
                                                    setDeleteFingerprintShow(true);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </CustomCard>
                            </div>
                        ))
                    ) : (
                        <NotInformation text={t('no_fingerprints_added_yet')} card={true} className="h-100 w-100" />
                    )}
                </div>
            </div>
            <DeleteModal
                show={deleteFingerprintShow}
                onHide={() => setDeleteFingerprintShow(false)}
                onClickFn={handleConfirmDelete}
                data={idsToDelete}
                isReset={setSelectedList}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('fingerprint')}
            />
        </>
    );
};

export default FingerprintsTable;
